import React from 'react';
import { FieldCheckForm } from '../../components/FieldCheck'
import { InteractiveWrapper } from '../../components/Interface';
import { FieldCheck as FieldCheckTemplate } from '../../components/Templates'

export const FieldCheck = () => {
    return (
      <InteractiveWrapper 
        name="field-check"
        title="Field Check"
        template={FieldCheckTemplate}
        initFunction="initFieldCheck"
        hasStyles={false}
      >
        <FieldCheckForm />
      </InteractiveWrapper>
    )
}